import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlideComponent } from './glide.component';
import { SVGModule } from '../svg/svg.module';

@NgModule({
  declarations: [GlideComponent],
  imports: [
    CommonModule,
		SVGModule
  ],
  exports: [
    GlideComponent,
  ],
})
export class GlideModule { }
